import {createAction} from "redux-act";
import {IPrediction, ISquad} from "apps/DRAW_PREDICTOR/modules/reducers";
import {IDictionary} from "modules/types";

export const addPrediction = createAction<IPrediction>();
export const clearPredictions = createAction();

export const setActivePot = createAction<number>();
export const setSelectedSquad = createAction<number>();
export const removeSelectedSquad = createAction();

export const fetchPredictionSimulate = createAction();
export const fetchPredictionSimulateSuccess = createAction<IPrediction[]>();
export const fetchPredictionSimulateFailed = createAction<Error["message"]>();

export const fetchPredictionSimulateLite = createAction();
export const fetchPredictionSimulateLiteSuccess = createAction<IPrediction[]>();
export const fetchPredictionSimulateLiteFailed = createAction<Error["message"]>();

export const fetchPredictions = createAction();
export const fetchPredictionsSuccess = createAction<IPrediction[]>();
export const fetchPredictionsFailed = createAction<Error["message"]>();

export const savePredictions = createAction();
export const savePredictionsSuccess = createAction<IPrediction[]>();
export const savePredictionsFailed = createAction<Error["message"]>();

export const savePredictionsInStorage = createAction();
export const checkSavedPredictions = createAction();

export const setPrediction1ForEdit = createAction<number>();
export const setPrediction2ForEdit = createAction<number>();
export const editPrediction = createAction<IDictionary<ISquad>>();

export const clearEditPredictionData = createAction();

export const setFullLockout = createAction();
